import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  TouchableOpacity
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import * as React from 'react'
// styles
import { globalStyles } from '../../../static/styles/global'
import Card from '../card/Card'
import { Entypo } from '@expo/vector-icons'
import { useEffect, useState } from 'react'

import moment from 'moment'
import { useLabourStore } from '../../../stores/labour'
import { ActivityIndicator } from 'react-native-paper'
import { useFocusEffect } from '@react-navigation/native'
import { useshiftstore } from '../../../stores/shift'
import { useTranslation } from 'react-i18next'

const Calendar_Stripe = ({
  showDays = true,
  headerShow = true,
  shiftLable = 'Current Shifts',
  shiftInfo = false,
  shiftInfoText = '',
  onChangeValue,
  onChangeWeek,
  displaydays = true,
  currentPosition = moment().week(),
  customerShifts = []
}): JSX.Element => {
  const [weekNo, setWeekNo] = useState(currentPosition)
  const { t } = useTranslation()


  const initialMonthChange = () => {
    return (
      moment().week(weekNo).startOf('week').format('MMM') +
      ' ' +
      moment().week(weekNo).startOf('week').format('DD') +
      ' - ' +
      (moment().week(weekNo).startOf('week').format('MMM') ===
        moment().week(weekNo).endOf('week').format('MMM')
        ? ''
        : moment().week(weekNo).endOf('week').format('MMM')) +
      ' ' +
      moment().week(weekNo).endOf('week').format('DD')
    )
  }
  const initialWeekText = initialMonthChange()
  const [weekText, setWeekText] = useState(initialWeekText)
  const [sunday, setSunday] = useState(
    moment().week(weekNo).startOf('week').format('MMDDYYYY')
  )
  const [saturday, setSaturday] = useState(
    moment().week(weekNo).endOf('week').format('MMDDYYYY')
  )


  const labourStore = useLabourStore()
  const shiftstore = useshiftstore()


  useFocusEffect(
    React.useCallback(() => {
      const fetchData = async () => {
        try {
          const currentWeek = moment().week()
          const startOfWeek = moment().week(weekNo).startOf('week')
          const endOfWeek = moment().week(weekNo).endOf('week')
          const newSunday = startOfWeek.format('MMDDYYYY')
          const newSaturday = endOfWeek.format('MMDDYYYY')
          onChangeWeek(sunday, saturday)
        } catch (error) {
          console.log(error)
        }
      }

      fetchData()
    }, [weekNo])
  )

  useFocusEffect(
    React.useCallback(() => {

      return () => {
        labourStore.setStartWeekDate(moment().startOf('week').format('MM/DD/YYYY'))
        labourStore.setEndWeekDate(moment().endOf('week').format('MM/DD/YYYY'))
        shiftstore.cleartimings()
      }
    }, [])
  )
  const [shiftTitle, setShiftTitle] = React.useState(shiftLable)
  const [clickedDay, setClickedDay] = React.useState('')

  const daysOrder = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  const generateDayModel = (startDay, currentWeek = moment().week()) => {
    const startIndex = daysOrder.indexOf(startDay);
    if (startIndex === -1) return [];

    let startOfWeek = moment().week(currentWeek).day(startIndex);

    if (startOfWeek.week() !== currentWeek) {
      startOfWeek.subtract(7, "days");
    }

    return Array.from({ length: 7 }, (_, i) => {
      const fullDayName = daysOrder[(startIndex + i) % 7];
      const dayShortName = ["thursday", "saturday", "sunday"].includes(fullDayName)
        ? fullDayName.slice(0, 1).toUpperCase() + fullDayName.slice(1, 2).toLowerCase()
        : fullDayName.slice(0, 1).toUpperCase();

      return {
        dayShortName,
        day: startOfWeek.clone().add(i, "days").format("YYYY-MM-DD"),
      };
    });
  };
  const backendStartDay = labourStore?.startdayofweekdata?.payPeriodDay ? labourStore?.startdayofweekdata?.payPeriodDay : 'monday'
  const [currentWeek, setCurrentWeek] = React.useState(moment().week());
  const [weekData, setWeekData] = React.useState(() => generateDayModel(backendStartDay, weekNo));
  const today = moment().format('YYYY-MM-DD')

  const shiftClicked = (day) => {
    setClickedDay(day)
    onChangeValue(day)
  }

  const dayItems = weekData.map((item, index) => {
    const hasShift = customerShifts.some(
      (shiftDay) => shiftDay['day'] === item.day
    )
    const isToday = item.day === moment().format('YYYY-MM-DD')
    return (
      <TouchableOpacity
        key={index.toString()}
        onPress={() => shiftClicked(item.day)}
      >
        <View
          style={[
            isToday ? styles.currentDay : styles.notCurrentDay,
            clickedDay == item.day && item.day != today && styles.clickedDay
          ]}
        >
          <View
            style={[{ alignItems: 'center', flex: 1 }]}
            key={index.toString()}
          >
            <View style={{ height: 10 }}>
              {isToday && (
                <Text style={{ fontSize: 10, textAlign: 'center' }}>{t('today')}</Text>
              )}
            </View>
            <View>
              <Text style={[globalStyles.calendarDay, { textAlign: 'center' }]}>
                {item.dayShortName}
              </Text>
            </View>
            <View>
              {(() => {
                const match = labourStore?.scheduleData?.ptoInfo?.find(
                  (req) => moment(item.day, "YYYY-MM-DD").isBetween(
                    moment(req.startTimeOff, "YYYY-MM-DD"),
                    moment(req.endTimeOff, "YYYY-MM-DD"),
                    null,
                    "[]"
                  )
                );


                if (match) {
                  return (
                    <View
                      style={{
                        width: 6,
                        height: 6,
                        backgroundColor: match.timeOffStatus === 0 || match.timeOffStatus === 2 ? "red" : "green",
                        borderRadius: 10,
                        marginTop: 5,
                      }}
                    />
                  );
                }

                return hasShift && <View style={styles.dayActive} />;
              })()}
            </View>
          </View>
        </View>
      </TouchableOpacity>
    )
  })


  const showWeek = (currentWeek, action, backendStartDay) => {
    const weekString = getWeekString(currentWeek, action);

    // Increment / decrement week
    if (action === 'add') {
      currentWeek = currentWeek + 1;
    } else {
      currentWeek = currentWeek - 1;
    }

    // Let moment resolve the correct YEAR for this week
    let baseWeekMoment = moment().week(currentWeek);

    // Backend start day index (Sunday = 0 ... Saturday = 6)
    const startDayIndex = moment().day(backendStartDay).day();

    // Calculate start of week
    let startOfWeek = baseWeekMoment.clone().day(startDayIndex);
    console.log("start of week", startOfWeek)

    // Fix alignment when backend week does not start on Sunday
    if (startOfWeek.week() !== baseWeekMoment.week()) {
      startOfWeek.subtract(7, 'days');
    }

    const endOfWeek = startOfWeek.clone().add(6, 'days');

    labourStore.setStartWeekDate(startOfWeek.format('MM/DD/YYYY'));
    labourStore.setEndWeekDate(endOfWeek.format('MM/DD/YYYY'));

    const updateDayModel = Array.from({ length: 7 }).map((_, i) => {
      const date = startOfWeek.clone().add(i, 'days');
      const shortName = date.format('dd');
      const isTwoLetterDay = ['Th', 'Sa', 'Su'].includes(shortName);

      return {
        dayShortName: isTwoLetterDay
          ? shortName.charAt(0).toUpperCase() + shortName.charAt(1).toLowerCase()
          : shortName.charAt(0).toUpperCase(),
        day: date.format('YYYY-MM-DD'),
      };
    });

    setWeekData(updateDayModel);
    setWeekText(weekString);
  };

  const getWeekString = (currentWeek, action) => {
    if (action == 'add') {
      currentWeek = currentWeek + 1
    } else {
      currentWeek = currentWeek - 1
    }
    if (currentWeek > moment().week()) {
      setShiftTitle('Future Shifts')

    } else if (currentWeek < moment().week()) {
      setShiftTitle('Previous Shifts')
    } else {
      setShiftTitle('Current Shifts')
    }
    setWeekNo(currentWeek)


    const startOfWeek = moment().week(currentWeek).startOf('week')
    const endOfWeek = moment().week(currentWeek).endOf('week')
    const startDayNumber = startOfWeek.date()
    const endDayNumber = endOfWeek.date()
    const startMonth = startOfWeek.format('MMM')
    const endMonth = endOfWeek.format('MMM')

    let weekText = ''

    if (startMonth === endMonth) {
      weekText = `${startMonth} ${startDayNumber} - ${endDayNumber}`
    } else {
      weekText = `${startMonth} ${startDayNumber} - ${endMonth} ${endDayNumber}`
    }
    let weekType = ''

    if (currentWeek === moment().week()) {
      weekType = 'Current Shifts'
    } else if (currentWeek < moment().week()) {
      weekType = 'Previous Shifts'
    } else {
      weekType = 'Future Shifts'
    }

    setShiftTitle(weekType)

    setWeekNo(currentWeek)

    setWeekText(weekText)

    onChangeValue(weekText)

    return weekText
  }
  return (
    <View>
      {headerShow && (
        <View style={globalStyles.shiftHeader}>
          <Text style={globalStyles.shiftTitle}>{shiftTitle}</Text>
        </View>
      )}
      <View style={[globalStyles.mt2, globalStyles.hContainer]}>
        <View style={{ width: '10%' }}>
          <TouchableOpacity
            onPress={() => {
              showWeek(weekNo, 'previous', backendStartDay)
            }}
          >
            <Entypo name="chevron-left" size={22} color="black" />
          </TouchableOpacity>
        </View>
        <View style={{ width: '80%' }}>
          <Text style={globalStyles.title}>{weekText}</Text>
        </View>
        <View style={{ width: '10%', flex: 1 }}>
          <TouchableOpacity
            onPress={() => {
              showWeek(weekNo, 'add', backendStartDay)
            }}
          >
            <Entypo
              name="chevron-right"
              size={22}
              color="black"
              style={{ textAlign: 'right' }}
            />
          </TouchableOpacity>
        </View>
      </View>

      <View>
        {showDays && weekNo >= moment().week() && (
          <View>
            {shiftInfo && (
              <View>
                <Text style={globalStyles.shiftInfo}>{shiftInfoText}</Text>
              </View>
            )}
          </View>
        )}
        {displaydays && (
          <View style={globalStyles.calendarDaysView}>{dayItems}</View>
        )}
      </View>
    </View>
  )
}
const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    width: '90%',
    marginTop: 10
  },
  customCardHeader: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    backgroundColor: '#0088CF',
    borderWidth: 0,
    width: '60%',
    marginTop: -18
  },
  myCard: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    backgroundColor: '#1978cd',
    marginBottom: 20,
    borderRadius: 5
  },
  dangerColor: {
    color: 'red',
    fontSize: 14
  },
  dayClass: {
    justifyContent: 'center',
    paddingLeft: 16,
    paddingRight: 16
  },
  dayActive: {
    width: 6,
    height: 6,
    backgroundColor: 'black',
    borderRadius: 10,
    marginTop: 5
  },
  currentDay: {
    borderWidth: 1,
    borderColor: '#438CD7',
    backgroundColor: '#9FC4E9',
    padding: 8,
    borderRadius: 30
  },
  notCurrentDay: {
    borderWidth: 1,
    borderColor: '#fff',
    backgroundColor: '#fff',
    padding: 8,
    borderRadius: 30
  },
  clickedDay: {
    borderWidth: 1,
    borderColor: '#c3c3c3',
    backgroundColor: '#f1f1f1',
    padding: 8,
    borderRadius: 30
  }
})
export default Calendar_Stripe
